/**
 * src/shell/agents/components/CopilotRibbon.tsx
 *
 * Proactive Co-Pilot Intelligence Ribbon.
 * Surfacing real-time contextual recommendations, layout refinements,
 * and security anomaly alerts directly above the generative canvas.
 */

import React from 'react';

export interface CopilotRibbonProps {
  onApplyMutation: (instruction: string) => void;
  detectedAnomalies?: string[];
}

export const CopilotRibbon: React.FC<CopilotRibbonProps> = ({
  onApplyMutation,
  detectedAnomalies = ['Unauthorized BLE proximity burst on Server Room 4B'],
}) => {
  const suggestions = [
    'Make the heatmap crimson',
    'Add Gossip Mesh Topology',
    'Include microCredit flow',
    'Filter anomalous door events',
  ];

  return (
    <div
      data-testid="copilot-ribbon"
      style={{
        background: 'rgba(30, 41, 59, 0.7)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '12px',
        padding: '10px 16px',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '12px',
      }}
    >
      {/* Left: Anomaly / Proactive status */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '14px' }}>✨</span>
        <span style={{ fontSize: '11px', fontWeight: 800, color: '#38bdf8' }}>
          PROACTIVE COPILOT:
        </span>
        {detectedAnomalies.length > 0 && (
          <span
            data-testid="copilot-anomaly-badge"
            style={{
              fontSize: '11px',
              color: '#fca5a5',
              background: 'rgba(239, 68, 68, 0.2)',
              padding: '2px 8px',
              borderRadius: '6px',
            }}
          >
            ⚠️ {detectedAnomalies[0]}
          </span>
        )}
      </div>

      {/* Right: Quick Mutation Chips */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '10px', color: '#94a3b8' }}>Try asking:</span>
        {suggestions.map((sug, idx) => (
          <button
            key={idx}
            type="button"
            data-testid={`copilot-suggestion-${idx}`}
            onClick={() => onApplyMutation(sug)}
            style={{
              fontSize: '10px',
              fontWeight: 600,
              color: '#cbd5e1',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '6px',
              padding: '3px 8px',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >
            + {sug}
          </button>
        ))}
      </div>
    </div>
  );
};
